import BaseService from './baseService';

class BillingInvoiceService extends BaseService {
	async getInvoices(opts = {}) {
    this.endPoint = '/invoices';
		return this.get(opts);
  }
  async getInvoicesByCompany(id, opts = {}) {
    this.endPoint = '/invoices/get_by_company?company_id='+id;
    return this.get(opts);
  }
  async createInvoice(payload){
    this.endPoint = '/invoices';
    return await this.post(payload); 
  }
  async updateInvoice(id,payload,opts={}){
    this.endPoint = '/invoices';
    return await this.putOne(id,payload,opts);
  }
  async deleteInvoice(id,opts={}){
    this.endPoint = '/invoices';
    return await this.delete(id,opts);
  }
}

export default new BillingInvoiceService();